
import { db } from '@/main'
import helpers from '@/helpers.js'
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { getAuth } from 'firebase/auth'
import { 
  doc,
  setDoc
} from "firebase/firestore";

export default {
  name: "create-group",
  components: {
    Multiselect,
  },
  props: [],
  data() {
    return {
      newGroup: {
        name: "",
      },
      resourceType: {
        label: this.$t("group-edit-type-Floor"),
        value: "Floor"
      },
      view: {
        status: "waiting",
        restricted: false,
        error: null,
      },
      bulkData: {
        enabled: false,
        count: 10,
        status: null,
      },
      tagInput: "",
      linkedResources: []
    };
  },
  watch: {
    linkedResources () {
      // update newGroup doc every time it changes
      this.newGroup.linkedResources = this.linkedResources.map(res => res.id)
    }
  },
  computed: {
    resourceDirectory() {
      return this.$store.state.resources.boundDirectory;
    },
    resourceSelection() {
      let arr = [];

      for (const key in this.$store.state.resources.boundDirectory) {
        let obj = {
          name: this.$store.state.resources.boundDirectory[key]["name"],
          id: this.$store.state.resources.boundDirectory[key]["id"],
        };
        arr.push(obj);
      }

      return arr;
    },
    groups() {
      return this.$store.getters.groups;
    },
    user() {
      return this.$store.getters.userData;
    },
    org() {
      return this.$store.getters.activeOrg;
    },
    formDisabled() {
      if (this.newGroup.name && this.newGroup.name.length) return false;
      return true;
    },
    groupTypes () {
      return [
        {
          label: this.$t("group-edit-type-Floor"),
          value: "Floor"
        },
        {
          label: this.$t("group-edit-type-Building"),
          value: "Building"
        },
        {
          label: this.$t("group-edit-type-Area"),
          value: "Area"
        },
        {
          label: this.$t("group-edit-type-custom-1"),
          value: "custom-1"
        },
        {
          label: this.$t("group-edit-type-custom-2"),
          value: "custom-2"
        }
      ]
    }
  },
  mounted() {
    // console.log('this.groups.length:', this.groups.length);
    // if(this.groups.length >= 10 && this.org.plan === 0) {
    //   console.log("restricting org")
    //   this.view.restricted = true
    // }

    if (!this.newGroup.id) {
      this.newGroup = new helpers.Group({
        orgLink: this.org.id,
      });
    }

    console.log("this.$route:", this.$route);

    if ("bulk" in this.$route.query) {
      // enable bulk mode
      this.bulkData.enabled = true;
    }
  },
  methods: {
    submitForm() {
      // clean up state
      this.view.status = "saving";
      this.view.error = null;

      if (this.bulkData.enabled) {
        this.bulkCreate();
      } else {
        this.createGroup();
      }
    },
    async createGroup() {
      console.log("creating group:", this.newGroup);

      let groupData = { ...this.newGroup };
      groupData.updater = this.user.id

      let groupObj = new helpers.Group(groupData);

      try {
        await setDoc(
          doc(db, "orgs", this.org.id, "groups", groupObj.id).withConverter(
            helpers.groupConverter
          ),
          groupObj,
          {
            merge: true,
          }
        );

        this.$toast.success(`${this.newGroup.name} added!`);

        this.$router.push(`/${this.org.name}/groups`);
      } catch (error) {
        console.log("err adding group:", error);
        this.view.error = error;
      }
    },
    async onImageUploadSuccess(res) {
      console.log("image upload success:", res);

      this.newGroup.image = res.filePath;
    },
    onImageUploadError(err) {
      console.log("err:", err);
      this.$toast.error(`Something went wrong caving your new logo`);
    },
    initImageUpload() {
      console.log("init image change");
      this.$refs.imageUploader.childNodes[0].click();
    },
    async bulkCreate() {
      console.log("bulk creating:", this.bulkData);

      const auth = getAuth();
      const user = auth.currentUser;
      let token = await user.getIdToken(user, true);

      this.newGroup.orgLink = this.org.id;

      let groupObj = new helpers.Group(this.newGroup);
      let processedObj = helpers.groupConverter.toFirestore(groupObj);

      let obj = {
        count: parseFloat(this.bulkData.count),
        type: "group",
        org: this.org.id,
        token: token,
        data: processedObj,
      };

      console.log("obj to post:", obj);

      try {
        let res = await fetch("/api/bulkcreate", {
          method: "post",
          body: JSON.stringify(obj),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        res = await res.json();

        console.log("res:", res);

        if (!res.error) {
          this.$toast.success(this.$t("gen-Bulk-create-complete"));

          this.$router.push(`/${this.org.name}/groups`);
        } else {
          throw res.message;
        }
      } catch (error) {
        console.log("Error:", error);
        this.view.error = error;
      }

      this.view.status = "waiting";
    },
    removeTag(tag) {
      console.log("remove tag:", tag);
      let newTags = this.newGroup.tags.filter((existingTag) => {
        return existingTag !== tag;
      });
      console.log("tags now:", newTags);
      this.newGroup.tags = newTags;
    },
    tagInputChange(e) {
      if (e.inputType !== "insertText") {
        return;
      }

      // if it doesn't have data, it was not a keypress, was enter or mouse click
      if (!e.data) {
        this.addTag();
      }

      if (this.tagInput.indexOf(",") > 0) {
        this.addTag();
      }
    },
    addTag() {
      let tags = this.tagInput.split(",");
      tags.forEach((tag) => {
        console.log("tag:", tag);
        if (tag.length) {
          this.newGroup.tags.push(tag.toLowerCase());
        }
      });
      this.tagInput = "";
    },
  },
};
